import React, { useEffect, useState } from 'react';

import { useTranslations } from '@p2l/react-utils';

import { DevFrameOpenButton, SignOutButton, StyledDialogBody } from './app.styles';
import { TextButton } from './buttons';
import { Dialog, DialogFooter, DialogHeader, DialogTitle } from './dialog';

const App = ({}: {}) => {
  const { translate } = useTranslations();

  const isDevFrame = window.location.href.includes('dev-frame');
  const [seconds, setSeconds] = useState(0);
  const [open, setOpen] = useState(false);
  const [logOutUrl, setLogOutUrl] = useState('');

  useEffect(() => {
    if (seconds <= 0) return;

    const id = setInterval(() => {
      setSeconds((s) => s - 1);
    }, 1000);

    return () => clearInterval(id);
  }, [seconds]);

  useEffect(() => {
    window.p2lInactivityDialogConfig.openDialog = (remainingSeconds: number, logOutUrl: string) => {
      onOpenDialog(remainingSeconds, logOutUrl);
    };
    window.p2lInactivityDialogConfig.closeDialog = () => {
      setOpen(false);
    };
  }, []);

  useEffect(() => {
    if (seconds === 0 && open) {
      redirectToLogOut();
    }
  }, [seconds]);

  const redirectToLogOut = () => {
    window.location.href = logOutUrl;
  };

  const onOpenDialog = (remainingSeconds: number, logOutUrl: string) => {
    setSeconds(remainingSeconds);
    setOpen(true);
    setLogOutUrl(logOutUrl);
  };

  return (
    <>
      {isDevFrame && <DevFrameOpenButton onClick={() => window.p2lInactivityDialogConfig.openDialog(30, '/log-out')}>Open dialog</DevFrameOpenButton>}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogHeader>
          <DialogTitle>{translate('Inactivity_Dialog_Title').replace('{remainingSeconds}', seconds.toString())}</DialogTitle>
        </DialogHeader>
        <StyledDialogBody>{translate('Inactivity_Dialog_Body')}</StyledDialogBody>
        <DialogFooter>
          <SignOutButton onClick={() => redirectToLogOut()}>{translate('Inactivity_Dialog_Sign_Out_Button')}</SignOutButton>
          <TextButton onClick={() => setOpen(false)}>{translate('Inactivity_Dialog_Stay_Signed_In_Button')}</TextButton>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default App;
